import React from 'react';
import { Bell } from 'lucide-react';

export function ManagerNotificationsTab({ ctx }) {
  const { notifications } = ctx;

  return (
    <div className="bg-white rounded-xl shadow-md border border-stone-200 p-6">
      <h2 className="text-2xl font-bold text-stone-800 mb-6">Notifications</h2>
      {notifications.length === 0 ? (
        <div className="text-center py-12 text-stone-500">
          <Bell className="w-12 h-12 mx-auto mb-3 text-stone-400" />
          <p>No notifications</p>
        </div>
      ) : (
        <div className="space-y-3">
          {notifications.map(notif => (
            <div
              key={notif.id}
              data-testid={`notification-${notif.id}`}
              className={`border rounded-lg p-4 ${notif.read ? 'border-stone-200 bg-white' : 'border-gray-300 bg-gray-50'}`}
            >
              <div className="font-semibold text-stone-800">{notif.title}</div>
              <div className="text-sm text-stone-600 mt-1">{notif.message}</div>
              <div className="text-xs text-stone-500 mt-2">{new Date(notif.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
